import { useState, useEffect, useCallback } from 'react'

import {
  BusinessAccountPoliciesModel,
  getBusinessAccountPolicies,
  transformBusinessAccountPoliciesDto,
} from '@marketplace-web/business-accounts/business-accounts-data'

function useFetchBusinessUserPolicies(businessAccountId?: number) {
  const [policies, setPolicies] = useState<BusinessAccountPoliciesModel>()

  const fetchBusinessAccountPolicies = useCallback(async () => {
    if (!businessAccountId) return
    const response = await getBusinessAccountPolicies({ businessAccountId })

    if ('errors' in response) return

    setPolicies(transformBusinessAccountPoliciesDto(response.terms))
  }, [businessAccountId])

  useEffect(() => {
    fetchBusinessAccountPolicies()
  }, [fetchBusinessAccountPolicies])

  return { policies }
}

export default useFetchBusinessUserPolicies
